<template>    
  <div class="home" ref="container"  v-resize="onResize"> 
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div class="left-element" >    
      <LeftBar @search-query="searchQuery" @search-query-json="searchQueryJson" @recent-query="recentQuery" />
    </div>
    <div class="right-element">
        <ScrollableVueCard :title="$t('lang.busqueda.SEARCH RESULT')" :chip="alarmasSeleccionadas" >
            <template v-slot:header>
                <div style="padding: 12px 20px;" :class="colorForItem" v-if="itemselected"> 
                    <v-row style="padding: 0">
                      <v-col cols="10" style="padding: 0 12px">
                          <h3 style="color: white; user-select: none;"> {{titleCard}} </h3> 
                      </v-col>
                      <v-col cols="2" style="padding: 0">
                        <h3 style="color: white; user-select: none;"> <v-icon>mdi-clock-outline </v-icon>{{date}} </h3> 
                      </v-col>
                  </v-row>
                </div>
                <div style="padding: 12px 20px;"  v-if="!itemselected"> <h3 style="color: white"> {{placeText ? placeText :  $t("lang.busqueda.MAKE SEARCH")}} </h3></div>
            </template>

            <Map :isFullScreen="true" :centers.sync="center" :url.sync="url" :multiples.sync="multiples" style="height: calc(100%);"/>

        </ScrollableVueCard>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import LeftBar from '@/components/ListaBusqueda/LeftBar/LeftBar.vue'
import ScrollableVueCard from '@/components/ScrollableVueCard/ScrollableVueCardMultipleSlots.vue'
import MainScrollableVueCard from '@/components/ScrollableVueCard/ScrollableVueCard.vue'
import DetalleAlarma from '@/components/DetalleAlarma/DetalleAlarma.vue'
import {AlertType, AlertStatus} from './helpers'
import Map from '@/components/GoogleMapKML/MapKML.vue'
import alarmas from '@/assets/Alarmas.json'

export default {
  name: 'HomeMap',
  components: {
    HelloWorld,
    LeftBar,
    ScrollableVueCard,
    DetalleAlarma,
    MainScrollableVueCard,
    Map,
  },
  methods:{
    async recentQuery(value){
        //console.log(value)
        this.url = value.url;
        this.center = [value.center];
        this.placeText = value.descripcion;
    },
    async searchQuery(value){
        //console.log(value)
        this.overlay = true
        await this.$BusquedaService.queryString(value.query, value.zoom)
        .then(response =>{
          //console.log("RESPONSE", response)
          this.url = response.kmzUrl
          this.placeText = this.multiples ? "Mostrando múltiples ubicaciones: " + this.current +  " de " + this.total: response.placeText
          this.center = this.multiples ? this.center.concat([response.center]) : [response.center]

          var array = [{
            fecha: new Date().toString(),
            query: value.query,
            zoom: value.zoom,
            center: response.center,
            descripcion: response.placeText,
            url: response.kmzUrl
          }]
          
          array = array.concat(this.historial ? this.historial : []);
    
          this.$DataService.alarmas.Save(array)

        })
        .catch(error => {
          //console.log('ERROR', error)
          this.url = undefined
          this.placeText = undefined
          this.center = []
        })
        .finally(() => {
          this.overlay = false
        })
    },
    async searchQueryJson(value){
      //console.log("searchQueryJson", value)

      try {
            // try to parse
            var jsonValue = JSON.parse(value.query)
            this.multiples = true;
            //console.log(jsonValue.places)

            this.total = jsonValue.places.length
            this.current = 1
            this.center = []

            var promise = await Promise.all(jsonValue.places.map(async (element) => {
              await this.searchQuery({zoom: value.zoom, query: element})
              this.current = this.current + 1;
              this.overlay = true
            }));      

            //console.log(promise)
            this.multiples =false
            this.overlay = false
        }
        catch(e) {
              //console.log(e.message)
        }
    },
    onResize () {
      this.getContainerDimension()
    },
    getContainerDimension() {
      //console.log(this.$refs.container.clientHeight);
      this.height = this.$refs.container.clientHeight;
      this.width = this.$refs.container.clientWidth;
    },
    async itemHandler(value){
      if(this.itemselected && value.id == this.itemselected.id)
        this.itemselected = null
      else
        await this.alarmaRequest(value);
    }
  },
  async mounted(){
    //console.log("mounted")
    this.getContainerDimension();
  },
  beforeDestroy() {
    window.clearTimeout(this.$options.timer);
  },
  data: () => ({
      AlertType,
      AlertStatus,
      itemselected: null,
      width: null,
      height: null,
      url: undefined,
      placeText: undefined,
      center: undefined,
      overlay: false,
      multiples: undefined,
      current: 0,
      total: 0,
  }),
  watch:{
      itemselected(){
        this.dateToString();
      }
  },
  computed:{
      itemSelectedTitle(){
        if(!this.itemselected)
            return this.$t("lang.alarmas.NO ALARM")
        else
            return this.$t("lang.alarmas.ATTENDED")
            
      },
      historial(){
        return this.$store.state.alarmas
      },
      alarmasSeleccionadas(){
          if (!this.$store.state.alarmas){
              return undefined
          }
          else if(this.itemselected){
              return this.$store.state.alarmas.filter(item => item.status == this.itemselected.status).length.toString()
          }
      },
      colorForItem(){
            switch(this.itemselected.tipo){
                case AlertType.BLUE: return "myblue"
                case AlertType.YELLOW: return "myyellow"
                case AlertType.GREEN: return "mygreen"
                case AlertType.RED: return "myred"
            }
      },
      titleMap(){
        return this.itemselected.cuenta + ' - ' + this.itemselected.descripcion + ' - ' + this.itemselected.ubicacion
      },
      titleCard(){
        //console.log(this.$moment(this.itemselected.fecha))
        return this.itemselected.cuenta + ' - ' + this.itemselected.descripcion + ' - ' +  this.$moment(this.itemselected.fecha).format("YYYY-MM-DD hh:mm:ss")
      }
    }
}
</script>

<style scoped>

.innerisSelected {
  width: 100%;
}

.isSelected {
  margin-left: -40%;
}

.myblue{
  background: #6495ED;
}

.myyellow{
   background: #BDB76B;
}

.mygreen{
  background: #32CD32;
}

.myred{
  background: #FF0000;

}

.home {
  width: 100%;
  overflow:auto;
  display: flex;
}

.left-element {
  float: left;
  width: 40%;
  min-width: 300px;
  max-width: 550px;
  height: calc(100vh - (48px + 30px));
  transition: margin .5s;

}

@media only screen 
and (min-device-width : 768px) 
and (max-device-width : 1024px){
  .left-element{
    min-width: 290px;
    max-width: 290px;
  }

  .isSelected {
    margin-left: -290px;
  }
}

.right-element {
  float: right; 
  width: 70%;
  flex-grow: 100;
  height: calc(100vh - (48px + 30px));
  padding: 4px;
}

</style>